'use client';

import { c as _c } from "react/compiler-runtime";
import { HowItWorksSection, DifferentiationSection, HomeSparkSection, HostAtYourPlaceSection } from '@/components/HomeTradeFocus';
import { HeroSectionV3 } from './HeroSectionV3';
import { ConsumerFastTrackV3 } from './ConsumerFastTrackV3';
import { SizzleForSectionV3 } from './SizzleForSectionV3';
import { DirectToRightPlaceV3 } from './DirectToRightPlaceV3';
import { FinalCTASectionV3 } from './FinalCTASectionV3';
export function HomeV3View() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="min-h-screen bg-white"><HeroSectionV3 /><ConsumerFastTrackV3 /><SizzleForSectionV3 /><DirectToRightPlaceV3 /><HowItWorksSection /><DifferentiationSection /><HomeSparkSection /><HostAtYourPlaceSection /><FinalCTASectionV3 /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}